import React from 'react';

import PropTypes from 'prop-types';
import { Box, Divider, StackView, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import AddInfoForm from './components/addInfoForm';
import VehicleInfoList from './components/vehicleInfoList';
import SectionHeading from '../sectionHeading';

const VehicleInfo = ({ vehicleInfo, setVehicleInfo }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { vehicleInfoHeading }
  } = localizedStrings;

  return (
    <div style={{ border: '1px solid #e3e3e3', padding: '1.5rem' }}>
      <StackView space={3}>
        <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>{vehicleInfoHeading}</Typography></SectionHeading>
        <AddInfoForm
          vehicleInfo={vehicleInfo}
          setVehicleInfo={setVehicleInfo}
        />
        {vehicleInfo.length > 0 && (
          <VehicleInfoList
            vehicleInfo={vehicleInfo}
            setVehicleInfo={setVehicleInfo}
          />
        )}
      </StackView>
      <Divider space={3} variant={{ inverse: true }} />
    </div>
  );
};

VehicleInfo.propTypes = {
  vehicleInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setVehicleInfo: PropTypes.func.isRequired
};

export default VehicleInfo;
